export default "__VITE_ASSET__innYS$iB__"